import PropTypes from 'prop-types'
import { useState } from 'react'
import { Message } from 'semantic-ui-react'

import APP, { epicErrorHandler, epicResponseHandler, epicServerRequest } from 'app'
import { trackEvent } from 'global-utils/Analytics'
import { VerificationCodeInput } from 'ui'

import { catchError, map } from 'rxjs/operators'

const VerifyRegistrationCode = ({ data }) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const requestValidateCode = (code) => {
    setLoading(true)
    trackEvent('Authentication', 'Signup', 'Code Verification')

    const $action = epicServerRequest('post', `${APP.api_url}/auth/register/code`, {}, { ...data, code }).pipe(
      map(
        epicResponseHandler((response) => {
          if (response.data?.[0]?.redirect) {
            document.location.href = response.data[0].redirect
          }
          setLoading(false)
          return {}
        }, {}),
      ),
      catchError(
        epicErrorHandler((response) => {
          setLoading(false)
          setError(response?.error?.msg || 'Error al verificar.')
          return {}
        }, {}),
      ),
    )

    $action.subscribe(Function.prototype)
  }

  return (
    <div>
      Te hemos enviado un <b>código</b> a tu email; válido por 5 minutos.
      <br />
      <br />
      <b>Escríbelo a continuación:</b>
      <br />
      <VerificationCodeInput disabled={loading} loading={loading} onComplete={requestValidateCode} />
      {!!error && (
        <Message error size="mini">
          {error}
        </Message>
      )}
    </div>
  )
}

VerifyRegistrationCode.propTypes = {
  data: PropTypes.shape({}).isRequired,
}

export default VerifyRegistrationCode
